import { render } from "./CardPublicacionFull.vue?vue&type=template&id=462d931c&lang=html"
import script from "./CardPublicacionFull.vue?vue&type=script&lang=js"
export * from "./CardPublicacionFull.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__